import React from 'react'
import { dishDrinkService } from '../../jwt/_services/ayb/dishDrinkService'

export const dishDrinkProvider = {
    getOptions, getPricesOptions
}

async function getOptions(data) {
    try {
        const listItems = await dishDrinkService.getOptions(data);

        return listItems.data.map((item) => {
            return (
                {
                    id: item.id,
                    value: item.code,
                    label: <label>{ item.title }</label>
                }
            )
        });
    } catch (error) {
        console.log(error)
    }
}

async function getPricesOptions(data) {
    try {
        const listItems = await dishDrinkService.getPrices(data);

        return listItems.map((item) => {
            return (
                {
                    id: item.id,
                    value: item.code,
                    label: <label>{ item.title }</label>
                }
            )
        });
    } catch (error) {
        console.log(error)
    }
}